import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { Ability } from 'ember-can';

export default class ToolMergeArtistAbility extends Ability {
  // Services
  @service permission;

  // Defaults
  @tracked recordType;

  // Getter and setter
  get actions() {
    return this.permissions?.actions;
  }

  get canRead() {
    return this.actions?.read;
  }

  get canUpdate() {
    return this.actions?.update;
  }

  get canViewNavigation() {
    return this.permissions?.options?.canViewNavigation ?? this.actions?.read;
  }

  get permissions() {
    return this.permission.for(this.recordType);
  }
}
